import Cookies from 'js-cookie';
import Routing from "routing";

/**
 * При загрузки страницы генерим и сохраняем в sessionStorage номер таба.
 */
(function(){
    // Constants
    const COOKIE_TAB_TOKEN_KEY = 'TAB_TOKEN',
          COOKIE_BROWSER_TOKEN_KEY = 'BROWSER_TOKEN';

    // Generate random token
    let rand = function(): string {
        return Math.random().toString(36).substr(2); // remove `0.`
    };
    let generateBrowserToken = function(): string {
        return rand() + rand(); // to make it longer
    };
    let generateTabToken = function (): string {
        return Math.floor(Math.random() * 1000000).toString();
    };

    $(window).on('load',function($) {
        let tab_id = sessionStorage.getItem(COOKIE_TAB_TOKEN_KEY),
            browser_id = localStorage.getItem(COOKIE_BROWSER_TOKEN_KEY),
            notReloadRoutes = [
                Routing.generate('admin_vision_system_security_login'),
                Routing.generate('admin_vision_system_security_check'),
                Routing.generate('admin_vision_system_security_logout')
            ],
            path = window.location.pathname;

        // При logout - сбрасываем tab_id в sessionStorage и Cookies
        if (path == Routing.generate('admin_vision_system_security_logout')) {
            sessionStorage.removeItem(COOKIE_TAB_TOKEN_KEY);
            Cookies.remove(COOKIE_TAB_TOKEN_KEY);
            window.location.href = Routing.generate('admin_vision_system_security_login');
            return;
        }

        // Save BrowserId
        if (browser_id == null || browser_id == 'null') {
            browser_id = generateBrowserToken();
            localStorage.setItem(COOKIE_BROWSER_TOKEN_KEY, browser_id);
        }
        Cookies.set(COOKIE_BROWSER_TOKEN_KEY, browser_id);

        // Save TabId
        if(tab_id == null || tab_id == 'null') {
            tab_id = generateTabToken();
            sessionStorage.setItem(COOKIE_TAB_TOKEN_KEY, tab_id);
            Cookies.set(COOKIE_TAB_TOKEN_KEY, tab_id);

            // Нам нужно перезагрузить страницу, чтобы backend получил запрос уже с новым
            // 'tab_id' для новой вкладки браузера. Для всех страниц в новой вкладке кроме login / logout.
            if (notReloadRoutes.indexOf(path) == -1) {
                document.location.reload();
            }
        } else {
            Cookies.set(COOKIE_TAB_TOKEN_KEY, tab_id);
        }
    });

    /**
     * До перехода по ссылке сохраняем в cookie значение
     * из sessionStorage, чтобы вместе с запросом в cookie передавался id таба,
     * чтобы потом на сервере мы смогли вытащить из сессии историю нужного нам таба.
     */
    $(window).on('beforeunload', function() {
        var tab_id = sessionStorage.getItem(COOKIE_TAB_TOKEN_KEY);
        if (tab_id && tab_id != 'null') {
            Cookies.set(COOKIE_TAB_TOKEN_KEY, tab_id);
        }
    });
})();
